import React from 'react';
import { useSearchParams } from 'react-router-dom';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Search Results
          </h1>
          <p className="text-gray-600">
            Search query: "{query}"
          </p>
          <p className="text-gray-500 mt-4">
            This page will display search results with filtering and sorting options.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
